/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import styled from 'styled-components';

export const TableViewContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  flex: 1;
`;

export const TableContent = styled.div`
  flex: 1;
  overflow: auto;
`;

export const CellValue = styled.div`
  font-size: 0.875rem;
  color: var(--cds-text-primary);
  margin-bottom: 0.25rem;
`;

export const HeaderRow = styled.div`
  display: flex;
  border-top: 1px solid var(--cds-border-subtle-01);
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0.5rem 1rem;
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
`;

export const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
`;
